// NO ENTERPRISE OBJECTS. An EO exists so RecordRail can list a component; this app has no rail
// of records and no detail pages to put one beside.

const enterpriseObjectMetadataClasses: Map<string, object> = new Map();

export default function EnterpriseObjectMetadataClassFactory(name: string): object | undefined{
    return enterpriseObjectMetadataClasses.get(name + "EnterpriseObjectMetadata");
}